/*
 * @Author: xuesong
 * @Date: 2021-05-14 14:06:08
 * @LastEditTime: 2021-05-27 11:57:01
 * @LastEditors: enbo.zhou@dsicm.com
 * @Description: In User Settings Edit
 * @FilePath: /dsicm-admin-web/src/views/StandardDatabase/api/index.js
 */

import request from '@/utils/req.js';

// 编辑科研代码列表
export function updateCategory(params) {
    return request.post("/admin/standard-category/update",params);
}

// 获取树形结构
export function getTreeData(params) {
    return request.post("/admin/standard-category/getStandardCategoryTree",params);
}

// 分类数据圆头
export function getClassification(params) {
    return request.post("/admin/standard-category/list",params);
}

// 新增科研代码
export function addCategory(params) {
    return request.post("/admin/standard-category/insert",params);
}

// 删除科研代码
export function deleteCategory(params) {
    return request.delete(`/admin/standard-category/${params}`);
}

// 获取编辑的详情回显
export function getCategoryDetail(params) {
    return request.get('/admin/standard-category/getCategoryDetial',params);
}


/****************** 药品类别 ***************/


export function addDrugInfo(params) {
    return request.post('/admin/drug-new/insert',params);
}

// 获取剂量
export function getDosageOrUnit(params) {
    return request.get(`/admin/category/${params}/children`);
}
export function getDrugList(params) {
    return request.post('admin/drug-new/page',params);
}


export function updateDrug(params) {
    return request.post('/admin/drug-new/update',params);
}
// 停用
export function updateEnable(params) {
    return request.put(`/admin/drug-new/updateStatus?id=${params}`);
}
// 删除 
export function deleteDrug(params) {
    return request.delete(`/admin/drug-new/${params}`);
}


// 标准数据库食材库树结构
export function apiGetFoodTree(params) {
    return request.get(`/admin/standard-category/getFoodTree`,params);
}


// 分页查询
export function apiPostFoodPage(params) {
    return request.post(`/admin/food/page`,params);
}

// 食材库添加
export function apiPostAddFood(params) {
    return request.post(`/admin/food`,params);
}
//食材库删除
export function apiDeleteFood(params) {
    return request.delete(`/admin/food/${params}`);
}

//食材库启用-停用
export function apiUpdateStatusFood(params) {
    return request.put(`/admin/food/updateStatus/${params}`);
}
//食材库详细查询
export function apiGetFood(params) {
    return request.get(`/admin/food/${params}`);
}
// 不良反应
export function adverseReactionPage(params) {
    return request.post(`/admin/adverse-reaction/page`,params);
}
// 不良反应大类
export function adverseReactionCategory(params) {
    return request.post(`/admin/adverse-reaction-category/list`,params);
}
// 病种
export function findIcdDiseaseByCondition(params) {
    return request.get(`/admin/disease-type/findDiseaseTypeByCondition`,params);
}
export function adverseReactionStage(params) {
    return request.post(`/admin/adverse-reaction-stage/list`,params);
}
export function adverseReactionCategoryInsertReturnId(data) {
    return request.post(`/admin/adverse-reaction-category/insertReturnId`,data);
}
// 病种
export function DiseaseType() {
    return request.get(`/admin/disease-type`);
}

export function adverseReactionPhenomenon(params) {
    return request.get(`/admin/adverse-reaction-phenomenon/enabled`,params);
}
export function adverseReactionAdd(data) {
    return request.post(`/admin/adverse-reaction`,data);
}
export function getInfoByAdverseReactionPhenomenonId(params) {
    return request.get(`/admin/adverse-reaction/getInfoByAdverseReactionPhenomenonId`,params);
}
export function PutAdverseReactionPhenomenonId(params) {
    return request.put(`/admin/adverse-reaction`,params);
}
export function patientCommonQuestion(params) {
    return request.post(`/admin/patient-common-question/getPatientFaqWithFuzzySearch`,params);
}
export function patientCommonQuestionDelete(params) {
    return request.delete(`/admin/patient-common-question/${params}`,);
}
export function saveCommonQuestions(params) {
    return request.post(`/admin/patient-common-question/saveCommonQuestions`,params);
}
export function updateCommonQuestions(params) {
    return request.put(`/admin/patient-common-question`,params);
}
export function getCommonQuestions(params) {
    return request.get(`/admin/patient-common-question/${params}`);
}
export function getTerminologyTree(params) {
    return request.post(`/admin/terminology/tree`,params);
}

export function metadatafindIcdDiseaseByCondition(params) {
    return request.get(`/dsicm-data-base/feign/disease-type/findIcdDiseaseByCondition`,params);
}
